import { render } from "./base-avatar.vue?vue&type=template&id=306d99ce&ts=true"
import script from "./base-avatar.vue?vue&type=script&lang=ts"
export * from "./base-avatar.vue?vue&type=script&lang=ts"

import "./base-avatar.vue?vue&type=style&index=0&id=306d99ce&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__